import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/freeplay/loot';
import {updateBalance} from '../../../reducers/games/actions';
import {redeemLootFreeplay} from '../../../reducers/lootbox/actions';
import Numeric from '../../components/numeric';
import BlueButton from '../../components/blue-button';
import {NumericFormat} from 'react-number-format';
import ModalsLib from '../../../lib/modals';
import {getCashoutsRange} from '../../../utils/sessions';
import tippy from 'tippy.js';
import Tooltip from '../../../utils/tooltips';
import {toast} from 'react-toastify';
import {setWalletPreset} from '../../../reducers/modals/actions';
import {navigate} from '../../../utils/navigation';

export default () => {
    const {user, game, login, data, buttons, sessions} = useSelector(Selector),
          dispatch = useDispatch();

    const cashout_range = getCashoutsRange({type: 'freeplay', amount: data.bonus, loginBalance: login.balance, sessions, roi_rate: user.roi_rate});

    const modalCloseHandler = () => {
        // console.log(`MODAL CLOSE`);
    }

    useEffect(() => {
        tippy('#cashoutRulesInfo', {
            placement: "top",
            animation: 'fade',
            theme: 'translucent',
            arrow: true,
            content: Tooltip.freeplay(cashout_range.rules),
            allowHTML: true
        });

        document.addEventListener('modal.close', modalCloseHandler);
        return () => document.removeEventListener('modal.close', modalCloseHandler);
    }, []);

    if(!login || login.status === 0)
        return <></>;

    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster">
            <div className="modal-header">
                <div className="title">
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.14536 4.52085H5.99953C5.93084 4.51805 5.86375 4.49932 5.80355 4.46614C5.74335 4.43296 5.69169 4.38624 5.65265 4.32966C5.61361 4.27308 5.58827 4.2082 5.57861 4.14014C5.56896 4.07209 5.57526 4.00272 5.59703 3.93751C5.80119 3.42418 5.98786 2.89918 6.13953 2.38585C6.26786 1.98918 6.76953 0.74668 8.02953 0.74668C8.52059 0.730945 8.99784 0.910667 9.35655 1.24641C9.71526 1.58215 9.92612 2.04648 9.94286 2.53751C9.94286 3.66335 8.66536 4.12418 8.19286 4.28751C7.52485 4.46183 6.83546 4.54039 6.14536 4.52085ZM8.02369 1.60418C7.35286 1.60418 7.04953 2.38001 6.97369 2.61918C6.86869 2.95751 6.75786 3.29585 6.63536 3.63418C7.05356 3.63152 7.46951 3.57266 7.87203 3.45918C8.20453 3.34251 9.03869 3.02751 9.03869 2.52001C9.02072 2.26575 8.90497 2.02833 8.71573 1.85758C8.52648 1.68682 8.27846 1.596 8.02369 1.60418Z" fill="white"/>
                        <path d="M5.83677 4.52082C5.16167 4.53271 4.48822 4.45025 3.83594 4.27582C2.38344 3.80332 2.08594 3.06249 2.08594 2.52582C2.08838 2.29915 2.13666 2.07531 2.22789 1.86779C2.31912 1.66027 2.4514 1.47336 2.61677 1.31832C2.9845 0.948381 3.4835 0.738717 4.0051 0.734985C4.9851 0.734985 5.48094 1.65082 5.84844 2.30415C6.08726 2.83973 6.28234 3.39376 6.43177 3.96082C6.44984 4.02517 6.45293 4.0928 6.44079 4.15853C6.42866 4.22426 6.40163 4.28633 6.36177 4.33999C6.32313 4.39417 6.27249 4.43868 6.2138 4.47005C6.1551 4.50142 6.08996 4.5188 6.02344 4.52082H5.83677ZM3.94094 1.60415C3.66392 1.61608 3.40242 1.73533 3.21177 1.93665C3.12862 2.00998 3.06139 2.09957 3.01423 2.19991C2.96708 2.30024 2.941 2.40918 2.9376 2.51999C2.9376 2.87582 3.36927 3.21999 4.10427 3.45915C4.53315 3.57001 4.97383 3.62877 5.41677 3.63415C5.32242 3.3235 5.20744 3.01949 5.0726 2.72415C4.73427 2.07665 4.4076 1.61582 3.95844 1.60415H3.94094Z" fill="white"/>
                        <path d="M11.3952 5.97921V5.25004C11.3952 4.82459 11.2262 4.41656 10.9253 4.11572C10.6245 3.81488 10.2165 3.64587 9.79102 3.64587H2.20768C1.78223 3.64587 1.3742 3.81488 1.07337 4.11572C0.772526 4.41656 0.603516 4.82459 0.603516 5.25004V5.97921H11.3952ZM6.43685 6.85421V13.2709H9.79102C10.2165 13.2709 10.6245 13.1019 10.9253 12.801C11.2262 12.5002 11.3952 12.0922 11.3952 11.6667V6.85421H6.43685ZM5.56185 6.85421H0.603516V11.6667C0.603516 12.0922 0.772526 12.5002 1.07337 12.801C1.3742 13.1019 1.78223 13.2709 2.20768 13.2709H5.56185V6.85421Z" fill="white"/>
                    </svg>

                    Free Play
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="game">
                    <div className="image" style={{backgroundImage: `url(${window.location.origin}/source/system/games/${game.slug}.png)`}}></div>
                    <div className="details">
                        <div className="top">
                            <div className="name">{game.name}</div>
                        </div>
                        <div className="bottom">
                            <div className="detail">
                                <div className="title">Login</div>
                                <div className="value">{login.login}</div>
                            </div>

                            <div className="balance">
                                <div className="detail">
                                    <div className="title">Balance</div>
                                    <div className="value">
                                        <Numeric value={login.balance} />
                                    </div>
                                </div>

                                <svg className={`${login.balance_details.need_update ? 'updating' : 'noupdating'}`} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"  onClick={e => {
                                    if(buttons.update)
                                        return;

                                    if(login.balance_details.need_update) {
                                        toast.dismiss();
                                        toast.info(`Your balance is already being updated...`);
                                        return;
                                    }

                                    dispatch(updateBalance(login.game));
                                }}>
                                    <path d="M18.3337 9.99996C18.3337 14.6 14.6003 18.3333 10.0003 18.3333C5.40033 18.3333 2.59199 13.7 2.59199 13.7M2.59199 13.7H6.35866M2.59199 13.7V17.8666M1.66699 9.99996C1.66699 5.39996 5.36699 1.66663 10.0003 1.66663C15.5587 1.66663 18.3337 6.29996 18.3337 6.29996M18.3337 6.29996V2.13329M18.3337 6.29996H14.6337" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {login.balance < 2 ? (
                    <>
                        {(data.error && data.ecode) ? (
                            <div className="modal-message warning">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span dangerouslySetInnerHTML={{__html: data.error}}></span>
                            </div>
                        ) : (
                            <div className="amount-block">
                                <div className="label">Amount</div>
                                <div className="input">
                                    <Numeric value={data.bonus} fixedDecimalScale={0} />
                                </div>

                                <div className="buttons">
                                    <div className="cashouts" id="cashoutRulesInfo">
                                        <div className="rules">
                                            Cashouts range
                                        </div>
                                        <div className="value">
                                            <span>{cashout_range.text}</span>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-tip data-for="cashoutRules">
                                                <rect width="20" height="20" rx="10" fill="#30344F"/>
                                                <path d="M11.7697 12.8984C11.5994 12.9584 11.0599 13.1013 10.8139 12.9741C10.7799 12.9562 10.7513 12.9312 10.7304 12.9011C10.7095 12.8709 10.697 12.8367 10.694 12.8012C10.6167 12.3554 10.9842 11.3252 11.183 10.7723C11.2492 10.588 11.2965 10.4537 11.3154 10.3722C11.459 9.77067 11.388 9.31059 11.1041 9.00482C10.7624 8.6369 10.1564 8.56532 9.65928 8.6319C9.15374 8.69294 8.65972 8.81599 8.19081 8.99768C8.16903 9.00723 8.14999 9.02124 8.13521 9.0386C8.12043 9.05595 8.1103 9.07619 8.10563 9.0977L8.00311 9.54206C7.99756 9.56705 7.99946 9.59293 8.00861 9.61704C8.01776 9.64114 8.03382 9.66261 8.05516 9.67923C8.07676 9.69549 8.10264 9.7064 8.13028 9.71091C8.15793 9.71542 8.18638 9.71336 8.21289 9.70495C8.40059 9.64208 8.98735 9.50063 9.19713 9.67494C9.31543 9.77353 9.2823 9.98214 9.23498 10.1379C9.18609 10.3008 9.12773 10.4765 9.06779 10.6608C8.67977 11.8568 8.23813 13.2127 8.93845 13.6356C9.26979 13.8648 9.67309 13.9924 10.0899 14C10.5 14 11.0063 13.8828 11.735 13.6156C11.757 13.6079 11.7767 13.5958 11.7928 13.5802C11.8089 13.5646 11.821 13.546 11.8281 13.5256L11.9779 13.0727C11.9864 13.0469 11.9868 13.0194 11.979 12.9934C11.9712 12.9674 11.9555 12.9439 11.9338 12.9255C11.912 12.9075 11.8851 12.8954 11.856 12.8906C11.827 12.8858 11.7971 12.8885 11.7697 12.8984ZM10.858 6C10.6324 6.00014 10.4119 6.06087 10.2243 6.17452C10.0368 6.28816 9.89063 6.44962 9.80436 6.63848C9.71808 6.82735 9.69555 7.03514 9.7396 7.23561C9.78366 7.43607 9.89233 7.6202 10.0519 7.76473C10.2114 7.90926 10.4147 8.0077 10.636 8.04761C10.8573 8.08752 11.0867 8.06711 11.2952 7.98896C11.5037 7.9108 11.6819 7.77842 11.8073 7.60853C11.9328 7.43863 11.9998 7.23887 12 7.03447C11.9999 6.76014 11.8796 6.49706 11.6654 6.30307C11.4513 6.10909 11.1609 6.00008 10.858 6Z" fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div className="modal-message warning">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>You cannot add a bonus into this game because <b>your game balance is more than $2</b>.</span>
                        </div>

                        <div className="modal-message info">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10 12.5L11.5 14L14.75 11" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Lower your game balance below <b>$2</b> to add bonus into this game. <b>If the balance is invalid, update it</b></span>
                        </div>
                    </>
                )}

                {(data.error && !data.ecode) && (
                    <div className="modal-message warning">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span dangerouslySetInnerHTML={{__html: data.error}}></span>
                    </div>
                )}
            </div>

            <div className="modal-footer">
                {(data.error && data.ecode) ? (
                    <>
                        {data.ecode === 'NOLOGIN' && (
                            <BlueButton active={buttons.add} onClick={e => {
                                navigate(`/game/${data.game}`);
                            }}>
                                Open Game
                            </BlueButton>
                        )}

                        {data.ecode === 'DEPOSITS_QUALIFICATION' && (
                            <BlueButton active={buttons.add} onClick={e => {
                                setWalletPreset({tab: 'deposit', mode: 'tabs'});
                                ModalsLib.open('wallet');
                            }}>
                                Make deposit
                            </BlueButton>
                        )}
                    </>
                ) : (
                    <>
                        {login.balance < 2 && (
                            <BlueButton active={buttons.add} onClick={e => {
                                dispatch(redeemLootFreeplay({
                                    game: data.game,
                                    prize_id: data.prize_id
                                }));
                            }}>
                                Load bonus
                            </BlueButton>
                        )}
                    </>
                )}
                <div className="button close" onClick={e => ModalsLib.close()}>
                    Close
                </div> 
            </div>
        </div>
    )
}